import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import Breadcrumb from './Breadcrumb';

const PathwayHero = ({ breadcrumb, title, subtitle, primaryCTA, secondaryCTA, heroImage }) => {
  return (
    <section className="relative pt-20 md:pt-24">
      {/* Hero Image Banner */}
      {heroImage && (
        <div className="relative w-full h-[40vh] md:h-[50vh] mb-0">
          <img
            src={heroImage}
            alt={title}
            className="w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>
          
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="max-w-5xl mx-auto px-4 md:px-6 text-center text-white">
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-3xl md:text-5xl font-bold mb-4"
              >
                {title}
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-lg md:text-xl mb-8"
              >
                {subtitle}
              </motion.p>
            </div>
          </div>
        </div>
      )}

      {/* Content Below Image */}
      <div className="bg-gradient-to-br from-teal-50 via-white to-blue-50 py-8 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb items={breadcrumb} />
          
          {!heroImage && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center"
            >
              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
                {title}
              </h1>
              <p className="text-lg md:text-xl text-gray-600 mb-8">
                {subtitle}
              </p>
            </motion.div>
          )}
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
            <Button asChild size="lg" className="btn-primary shadow-lg">
              {primaryCTA.link.startsWith('#')
                ? <a href={primaryCTA.link}>{primaryCTA.text}</a>
                : <Link to={primaryCTA.link}>{primaryCTA.text}</Link>}
            </Button>
            {secondaryCTA && (
              <Button asChild size="lg" variant="outline">
                {secondaryCTA.link.startsWith('#')
                  ? <a href={secondaryCTA.link}>{secondaryCTA.text}</a>
                  : <Link to={secondaryCTA.link}>{secondaryCTA.text}</Link>}
              </Button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PathwayHero;
